import { Operator } from '@/common/model/operator'

export const AuthApiPath = {
  LOGIN: '/api/auth/login', // POST Login
  LOGOUT: '/api/auth/logout', // POST Logout
  ME: '/api/auth/me' // GET Me
}

export type AuthApiPath = (typeof AuthApiPath)[keyof typeof AuthApiPath]

export interface LoginVars {
  // プロジェクト番号（"w2"=W2オペレーター / それ以外=該当サイトのサイトオペレーター）
  project_number: string
  email: string
  password: string
}

export interface LogoutVars {}

export interface GetMeResponse extends Operator {
  type?: 'w2' | 'site'
  is_admin?: boolean
  // サイト内管理操作（オペレーター/権限テンプレートの新規・編集・削除）が可能か
  can_manage?: boolean
  site_id?: number | null
  permission_template_id?: number | null
  permission_template_name?: string | null
  // ロール（'w2' / 'site_owner' 等）。/me が返す（backend/routers/auth.py）
  role?: string | null
  // メニュー権限（メニューキー→可否）。W2 は空
  menu_permissions?: Record<string, boolean> | null
}

export interface LoginResponse {
  token: string
  operator: Operator
}

export interface LogoutResponse {
  ok: boolean
}
